<template>
  <div class="signup-root">
    <div class="signup-scroll-container">
      <div class="signup-content-wrapper">
        <div class="fonts-white">
          
          <!-- Logo Section -->
          <div class="logo-section">
            <LogoWhite @click="handleClickMenu('muzible')" class="logo-clickable"></LogoWhite>
          </div>

          <!-- Typing Animation Header -->
          <div class="typing-section">
            <div class="typing-container">
              <div class="fonts-head typing-text" id="feature-text">
                {{ dynamicText }}
                <span class="cursor"></span>
              </div>
            </div>
          </div>

          <!-- Signup Card -->
          <div class="signup-card-section">
            <div class="signup-card">
              <v-card class="signup-form-card">
                <v-card-text class="signup-form-content">
                  <v-form ref="formsignup" v-model="valid" id="check-signup-form">
                    <v-text-field 
                      v-model="email" 
                      class="email-font mb-4" 
                      :rules="emailRules"
                      label="ENTER EMAIL" 
                      required 
                      color="#1ff050" 
                      @focus="checkErrorsRegister()"
                      :error-messages="emailValidationErrors"
                      variant="outlined"
                      density="comfortable"
                    ></v-text-field>
                    
                    <v-text-field 
                      autocomplete="current-password" 
                      class="password-font mb-4"
                      v-model.lazy="pass" 
                      :rules="passwordRules" 
                      label="ENTER PASSWORD"
                      :append-inner-icon="value ? 'mdi-eye' : 'mdi-eye-off'" 
                      @click:append-inner="() => (value = !value)"
                      :type="value ? 'password' : 'text'" 
                      @input="pass = $event.target.value"
                      required 
                      color="#1ff050"
                      variant="outlined"
                      density="comfortable"
                    ></v-text-field>
                    
                    <!-- Terms Checkbox -->
                    <div class="terms-checkbox-section">
                      <v-checkbox 
                        v-model="checkboxSignup" 
                        :rules="[v => !!v || 'You must agree to continue!']" 
                        required
                        color="#1ff050"
                        hide-details
                        density="compact"
                        class="terms-checkbox"
                      >
                        <template v-slot:label>
                          <span class="terms-label">
                            Accept our 
                            <span class="terms-link" @click.stop="handleClickMenu('Terms')">Terms of use</span>
                            and
                            <span class="terms-link" @click.stop="handleClickMenu('Privacy')">Privacy policy</span>
                          </span>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-form>

                  <!-- Sign Up Button -->
                  <div class="button-section">
                    <v-btn 
                      type="submit" 
                      form="check-signup-form" 
                      :disabled="!valid" 
                      color="#000000"
                      variant="outlined"
                      class="signup-btn"
                      size="large"
                      block
                      @click="register($event)"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      <span>Sign up</span>
                    </v-btn>
                  </div>

                  <!-- Log In Link -->
                  <div class="login-link-section">
                    <span class="sign-up-text-policy">
                      Already a member?
                      <span class="link-accept-signup" @click="handleClickMenu('login')">
                        Log in
                      </span>
                    </span>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Footer Links -->
              <div class="footer-links">
                <div class="footer-buttons-container">
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Terms')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-file-document-outline</v-icon>
                    <span>Terms of use</span>
                  </button>
                  
                  <div class="separator-dot"></div>
                  
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Privacy')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-shield-lock-outline</v-icon>
                    <span>Privacy policy</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LogoWhite from '../components/logo_white.vue';

export default {
  name: 'Signup',

  components: {
    LogoWhite
  },
  props: ['token'],
  data: () => ({
    delay: 80,
    value: true,

    dynamicText: '',
    text: 'Create new account',

    valid: false,
    email: '',
    pass: '',
    user: null,
    loggedUser: false,
    emailValidationErrors: [],
    checkboxSignup: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Password must have 7+ characters',
      v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
      v => /(?=.*\d)/.test(v) || 'Must have one number',
      v => /([!@#$%^&*])/.test(v) || 'Must have one special character [!@#$%^&*]'
    ],

  }),
  mounted() {
    this.typeText(0);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    async email(val) {
      this.emailValidationErrors = ['Checking email..'];
      let resultcheck = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(val)
      if (resultcheck) {
        try {
          const res = await this.$store.dispatch('checkEmail', { email: val }); // If value has been changed since start of function quit because result of last launched win 
          if (val !== this.email) return

          if (res.data === 0) {
            this.emailValidationErrors = ['E-mail already in use'];
            return false;
          } else {
            this.emailValidationErrors = [];
            return true;
          }
        } catch (error) {
          if (!error.response) {
            this.emailValidationErrors = ['Service is down.. Try again later!'];
          } else if (error.response.status === 500) {
            this.emailValidationErrors = ['Service is down.. Try again later!'];
          } else {
            this.emailValidationErrors = ['E-mail already in use'];
          }
          return false;
        }
      } else {
        this.emailValidationErrors = ['E-mail must be valid'];
        return false;
      }
    },
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
      if (this.user != null) {
        this.loggedUser = true;
      }
    },
  },
  computed: {
    emailRules() {
      return [
        v => {
          var val = !!v
          if (val) {
            return true
          } else {
            this.emailValidationErrors = [];
            return 'E-mail is required'
          }
        },
        v => {
          const isValid = /.+@.+/.test(v);
          if (!isValid) {
            this.emailValidationErrors = [];
          }
          return isValid || 'E-mail must be valid';
        },
        v => {
          const isValid = /(^.+@(\[?)[a-zA-Z0-9-.]+.([a-zA-Z]{2,3}|[0-9]{1,3})(]?)$)/.test(v);
          if (!isValid) {
            this.emailValidationErrors = [];
          }
          return isValid || 'E-mail must be valid';
        },
        v => {
          const isValid = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v);
          if (!isValid) {
            this.emailValidationErrors = [];
          }
          return isValid || 'E-mail must be valid';
        }
      ]
    },
  },
  created() {
    this.user = this.$store.getters.getUserData;

    if (this.user != null) {
      this.loggedUser = true;
    }

    if (this.$refs.formsignup) {
      this.$refs.formsignup.resetValidation();
    }

  },
  methods: {

    async typeText(num) {
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text = '1. Type in email'
        this.dynamicText = '';
        this.typeText(1);
      } else if (num === 1) {
        this.text = '2. Set password'
        this.dynamicText = '';
        this.typeText(2);
      } else if (num === 2) {
        this.text = 'Log in and enjoy!'
        this.dynamicText = '';
        this.typeText(3);
      } else {
        await this.waitForMs(4000);
        this.dynamicText = '';
        this.text = 'Create new account'
        this.typeText(0)
      }
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link) {
      if (link === 'Terms') {
        window.open('https://muzible.com/terms', '_blank');
      } else if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
    register(e) {
      this.valid = false;
      this.email = this.email.trim();

      this.$store.dispatch('register', {
        email: this.email,
        pass: this.pass,
        locale: 'en',
        refsource: this.$store.getters.getReferalSource,
        refmedium: this.$store.getters.getReferalMedium,
        refcampaign: this.$store.getters.getReferalCampaign
      }
      ).then(response => {
        this.user = this.$store.getters.getUserData;
        this.loggedUser = true;

        this.gotorootdash();
      }).catch(error => {
        if (!error.response) {
          this.emailValidationErrors = ['Service is down.. Try again later!'];
        } else {
          this.emailValidationErrors = ['Sign Up failed..'];
        }
      });

      e.preventDefault()
    },
    gotorootdash() {
      if (this.$store.getters.getMuze) {
        window.location.href = 'https://muze.muzible.com';
      } else if (this.$store.getters.getNFT) {
        window.location.href = 'https://verse.muzible.com';
      } else {
        this.$router.push({ name: 'plan' });
      }
    },
    checkErrorsRegister() {
      if (this.emailValidationErrors.length != 0
        && (this.emailValidationErrors[0] === 'Service is down.. Try again later!' ||
          this.emailValidationErrors[0] === 'Sign Up failed..')) {
        this.emailValidationErrors = [];
      }
    },


  },
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Signup Root - Complete Override */
.signup-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  overflow: hidden !important;
  z-index: 1 !important;
}

/* Signup Scroll Container - Main Scrollable Area */
.signup-scroll-container {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.95), rgba(18, 18, 18, 0.95));
  
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Signup Content Wrapper */
.signup-content-wrapper {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 60px 20px;
}

/* Logo Section */
.logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.logo-clickable {
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.logo-clickable:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

/* Typing Section */
.typing-section {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.typing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 32px;
  background-color: white;
  margin-left: 4px;
  animation: blink 0.6s linear infinite alternate;
}

@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

/* Signup Card Section */
.signup-card-section {
  display: flex;
  justify-content: center;
  min-width: 370px;
  max-width: 500px;
}

.signup-card {
  width: 100%;
  max-width: 500px;
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.signup-form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.signup-form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.signup-form-content {
  padding: 32px 24px !important;
}

/* Button Section */
.button-section {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* Login Link Section */
.login-link-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* Form Fields */
.email-font,
.password-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
}

.email-font :deep(.v-field),
.password-font :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
}

.email-font :deep(.v-field__outline),
.password-font :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.2);
}

.email-font :deep(.v-field--focused .v-field__outline),
.password-font :deep(.v-field--focused .v-field__outline) {
  color: #1ff050 !important;
}

.email-font :deep(.v-field__input),
.password-font :deep(.v-field__input) {
  color: white !important;
}

.email-font :deep(.v-label),
.password-font :deep(.v-label) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.email-font :deep(.v-field--focused .v-label),
.password-font :deep(.v-field--focused .v-label) {
  color: #1ff050 !important;
}

/* Terms Checkbox Section */
.terms-checkbox-section {
  margin-top: 8px;
  margin-bottom: 8px;
}

.terms-checkbox :deep(.v-selection-control) {
  min-height: auto !important;
}

.terms-checkbox :deep(.v-selection-control__wrapper) {
  align-items: flex-start;
}

.terms-checkbox :deep(.v-checkbox .v-selection-control__input) {
  margin-top: 2px;
}

.terms-label {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  line-height: 1.4;
}

.terms-link {
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 2px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.terms-link:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Signup Button */
.signup-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(31, 240, 80, 0.5) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.1) 0%, rgba(31, 240, 80, 0.05) 100%) !important;
  color: #1ff050 !important;
  transition: all 0.3s ease;
}

.signup-btn:hover:not(:disabled) {
  border-color: rgba(31, 240, 80, 0.8) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.2) 0%, rgba(31, 240, 80, 0.1) 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(31, 240, 80, 0.2);
}

.signup-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Log In Link */
.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  text-align: center;
}

.link-accept-signup {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 4px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-accept-signup:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Footer Links */
.footer-links {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.footer-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  outline: none;
}

.footer-link-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.footer-link-btn:active {
  transform: translateY(0);
}

.footer-link-icon {
  opacity: 0.8;
}

.separator-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

/* Button Overlay Override */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .signup-content-wrapper {
    padding: 120px 16px 60px 16px;
  }

  .typing-text {
    font-size: 24px;
  }

  .cursor {
    height: 24px;
  }

  .signup-form-content {
    padding: 24px 20px !important;
  }

  .signup-btn {
    font-size: 16px !important;
    padding: 20px !important;
  }

  .footer-links {
    margin-top: 24px;
    padding-top: 20px;
  }

  .footer-buttons-container {
    gap: 12px;
  }

  .footer-link-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .terms-label {
    font-size: 13px !important;
  }
}

@media (max-width: 480px) {
  .signup-content-wrapper {
    padding: 80px 16px 60px 16px;
  }

  .typing-text {
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }

  .signup-form-content {
    padding: 20px 16px !important;
  }

  .footer-buttons-container {
    flex-direction: column;
    gap: 8px;
  }

  .separator-dot {
    display: none;
  }

  .footer-link-btn {
    width: 100%;
    justify-content: center;
  }

  .terms-label {
    font-size: 12px !important;
  }
}

/* Loading State for Button */
.signup-btn :deep(.v-btn__loader) {
  color: #1ff050 !important;
}

/* Focus States */
.email-font :deep(.v-field--focused),
.password-font :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(31, 240, 80, 0.2);
}

/* Error State */
.email-font :deep(.v-field--error .v-field__outline),
.password-font :deep(.v-field--error .v-field__outline) {
  color: #d32f2f !important;
}

.email-font :deep(.v-field--error .v-label),
.password-font :deep(.v-field--error .v-label) {
  color: #d32f2f !important;
}

/* Accessibility */
.signup-btn:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
}

.link-accept-signup:focus-visible,
.terms-link:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-link-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* Checkbox Custom Styling */
.terms-checkbox :deep(.v-selection-control__input .v-icon) {
  color: #1ff050 !important;
}

.terms-checkbox :deep(.v-selection-control--disabled) {
  opacity: 0.5;
}

</style>